import { Navigate } from 'react-router-dom';

export default function CompletedPage() {
  return <Navigate to="/team?tab=completed" replace />;
}
